import React, {useState} from "react";
import axios from "axios";
import "./AdminPage.css";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {Button, TextField} from "@mui/material";
import { useHistory } from 'react-router-dom';



function TabPanel(props) {
 const { children, value, index, ...other } = props;

 return (
  <div
   role="tabpanel"
   hidden={value !== index}
   id={`vertical-tabpanel-${index}`}
   aria-labelledby={`vertical-tab-${index}`}
   {...other}
   style={{ marginLeft: "20px", paddingTop: "15px" }}
  >
   {value === index && (
    <Box>
     <Typography>{children}</Typography>
    </Box>
   )}
  </div>
 );
}

TabPanel.propTypes = {
 children: PropTypes.node,
 index: PropTypes.number.isRequired,
 value: PropTypes.number.isRequired,
};

function a11yProps(index) {
 return {
  id: `vertical-tab-${index}`,
  "aria-controls": `vertical-tabpanel-${index}`,
 };
}



const NewCourse=()=> {


  //const apiUrl = 'http://localhost:3045/course/';
   const apiUrl ="https://atci.ABCtalentacademy.accenture.com/abc-talent-apis/course/"

  const history= useHistory();

  const [title,setTitle]= useState('');
  const [value, setValue] = React.useState(0);

  const handleChange1=(e)=>{
    setTitle(e.target.value);
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
   };

  const handleSubmit =async(e)=>{
    e.preventDefault();

    //api call to create object in db with title as c_title.
    try{
    const response = await axios.post(apiUrl, {title:title});
    
    console.log('Document created:', response.data);
    // Handle successful response
    history.push(`Courses/${title}`);
  } catch (error) {
    console.error('Error creating document:', error);
    // Handle error
  }

  }

 
 return (
  
  <Box
   sx={{
    flexGrow: 1,
    bgcolor: "background.paper",
    display: "flex",
    height: "300px",
    marginBottom: "100px",
    marginTop: "50px",
   }}
  >
  
   <Tabs
    className="admin-vertical-tabs"
    orientation="vertical"
    value={value}
    onChange={handleChange}
    aria-label="Vertical tabs example"
    
    sx={{ borderRight: 1, borderColor: "divider", height: "300px" }}
   >
    <Tab
     className="admin-tab"
     sx={{
      background: "white",
      color: "black",

      margin: "5px 5px 10px 5px",
      textTransform: "none",
      fontWeight: "500",
     }}
     label="Creation of New Skill Page"
     {...a11yProps(0)}
    />
    <Tab
     className="admin-tab"
     sx={{
      background: "white",
      color: "black",

      margin: "5px 5px 10px 5px",
      textTransform: "none",
      fontWeight: "500",
     }}
     label="Item 2"
     {...a11yProps(1)}
    />
    <Tab
     className="admin-tab"
     sx={{
      background: "white",
      color: "black",
      margin: "5px 5px 10px 5px",
      textTransform: "none",
      fontWeight: "500",
     }}
     label="Item 3"
     {...a11yProps(2)}
    />
   </Tabs>

   <TabPanel value={value} index={0}>
    <Stack spacing={1}>
     <Typography sx={{ color: "blueviolet", fontSize: "18px", fontWeight: "600" }}>
      Creating a New Skill Page
     </Typography>

     <Stack direction={"row"} spacing={3} alignItems={"center"}>
      <Typography>Please enter the name of skill :</Typography>
      <FormControl sx={{ width: "200px" }}>
      <TextField type="text" value={title} onChange={handleChange1}/>
       
      </FormControl>
      
     </Stack>
     <br />
     <div className="center">
     <Button
      className="upload-button"
      type="submit"
      style={{
       background:"blueviolet",
       color:"white",
       fontSize: "14px",
       padding: "0px !important",
       width: "100px",
       height: "30px",
      }}
      disabled={title===''}
      onClick={handleSubmit}
     >
      Create
     </Button>
     </div>
     <br />
     <Box sx={{ width: "600px", background: "lightgrey" }}>
       <Typography sx={{ fontSize: "12px", padding: "8px" }}>
        <em>Instruction:</em> Clicking on "<strong>Create</strong>" button will redirect you to the newly created skillpage.
       </Typography>
      </Box>
    </Stack>
   </TabPanel>







   <TabPanel value={value} index={1}>
    <Stack spacing={1}>
     <Typography sx={{ color: "blueviolet", fontSize: "18px", fontWeight: "600" }}>
      Item 2
     </Typography>
     
    </Stack>
   </TabPanel>
   <TabPanel value={value} index={2}>
    <Stack spacing={1}>
     <Typography sx={{ color: "blueviolet", fontSize: "18px", fontWeight: "600" }}>
      Item 3
     </Typography>

     
    </Stack>{" "}
   </TabPanel>
  </Box>
 );
}

export default NewCourse;
